import { Tooltip, colors, IconButton } from '@sweep-io/sweep-design';
import { Pin } from '@sweep-io/sweep-design/dist/icons';
import { Stack } from '@mui/material';
import useSendBiEvent from '../../../../hooks/useSendBiEvent';
import { AI_AGENTS_EVENTS } from '../../../../services/events';

interface CardPinProps {
  isPinned: boolean;
  groupId: string;
  onPinClick: (groupId: string, isPinned: boolean) => void;
  isCardLoading: boolean;
}

export const CardPin = ({ isPinned, groupId, onPinClick, isCardLoading }: CardPinProps) => {
  const sendBiEvent = useSendBiEvent();

  return (
    <Tooltip title={`${isPinned ? 'Unpin from' : 'Pin for'} quick access`}>
      <IconButton
        variant={isCardLoading ? 'system' : 'flat'}
        size="tiny"
        disabled={isCardLoading}
        onClick={(e) => {
          if (!isPinned) {
            sendBiEvent({ name: AI_AGENTS_EVENTS.promptsLibraryPinCategory });
          }
          e.stopPropagation();
          onPinClick?.(groupId, !isPinned);
        }}
      >
        <Stack
          sx={{
            '& svg path': {
              stroke: isPinned ? colors.black : `${colors.grey[300]} !important`,
            },
          }}
        >
          {/* //TODO investigate why color prop is not working */}
          <Pin size="medium" />
        </Stack>
      </IconButton>
    </Tooltip>
  );
};
